import { render } from "./GraficoIPP.vue?vue&type=template&id=7893a64a&scoped=true"
import script from "./GraficoIPP.vue?vue&type=script&lang=js"
export * from "./GraficoIPP.vue?vue&type=script&lang=js"

import "./GraficoIPP.vue?vue&type=style&index=0&id=7893a64a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7893a64a"]])

export default __exports__